/**
 * @file step
 * @author zhaomiaoyuan
 */
import React, {useState, useEffect} from 'react';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
import Modal from 'antd/lib/modal';

import RadioFormItem from '../../components/RadioFormItem/index.tsx';
import CallingCardSelect from '../../components/CallingCard/callingCardSelect.tsx';
import PersonModal from './personModal';
import CompanyModal from './companyModal';
import GovernmentModal from './governmentModal';
import FeedbackModal from './feedbackModal';
import {recordProxy, bCat_2055_request} from '../../util';
// import TextAreaFormItem from '../../components/TextAreaFormItem/index.tsx';
// import UploadProof from '../../components/UploadProof/index.tsx';
import AgreeProtocol from '../../components/AgreeProtocol/index.tsx';
import {Button, message} from 'antd';
import {initCaptcha} from '../../../src/constants/utils';

// import {
//     feedbackTip
// } from '../../components/UploadProof/uploadTip.tsx';
import {
    initialStateErr, initialQuestionStateErr, formateTypeList,
    FEEDBACK_TYPE, FEEDBACK_OTHER, BELONG_TYPE, QUESTION_OPTIONS, QUESTION_OPTIONS2,
    OCCUPY_TYPE, MARK_TYPE, isTelephone, isMobilePhone
} from './conf';
// import {appealTypeEventTracking} from './conf';
// import {reg9, reg400800} from '../../components/util';

import './appeal.less';
const Step2 = (props) => {
    const {
        updateAppeal,
        appealData,
        cleanAppeal,
        appealSubmit
    } = props;
    const [telType, setTelType] = useState('');
    useEffect(() => {
        let phoneType = 0;
        if (isTelephone(appealData.phone)) {
            phoneType = 'tel';
        }
        if (isMobilePhone(appealData.phone)) {
            phoneType = 'phone';
        }
        setTelType(phoneType);
    }, [appealData.phone]);
    function rewrite() {
        recordProxy('rewrite', 'click', '');
        cleanAppeal();
        window.scrollTo(0, 0);
    }
    const onChangeCallback = (val) => {
        updateAppeal({
            phone: val.phone,
        });
    };
    const preClick = () => {
        recordProxy('prevStep', 'click', '');
        updateAppeal({
            curStep: 1,
            ...initialStateErr,
        });
        window.scrollTo(0, 0);
    };
    async function verifyCheck(value, updateType) {
        if (!value) {
            updateAppeal({
                [updateType + 'Err']: '不能为空'
            });
            return false;
        }
        updateAppeal({
            [updateType + 'Err']: ''
        });
        return true;
    }
    async function verifyUploadCheck(value, updateType) {
        if (!value.length) {
            updateAppeal({
                [updateType + 'Err']: '不能为空'
            });
            return false;
        }
        if (!appealData[updateType + 'Err'].length) {
            updateAppeal({
                [updateType + 'Err']: ''
            });
            return true;
        }
    }

    const nextClick = async() => {
        recordProxy('report-feedback_submit', appealData.phone, '');
        const {questionType, attributionType, questionContent, questionImg} = appealData;
        const questionTypeVerify = await verifyCheck(questionType, 'questionType');
        // 如果没有选问题类型，则不进行下一步操作
        if (!questionTypeVerify) {
            return;
        }
        let params = {
            phone_type: questionType,
        };
        // 反馈有关的问题类型：空号、无法接通、非该企业/政府号码、其他
        if (FEEDBACK_TYPE.includes(questionType)) {
            if (questionType === FEEDBACK_OTHER) {
                const questionContentVerify = await verifyCheck(questionContent, 'questionContent');
                // 反馈有关类型选择其他时，需要针对问题说明必填校验
                if (!questionContentVerify) {
                    return;
                }
            }
            params = {
                ...params,
                phone_feed: [appealData.phone],
                content: questionContent,
                img_id: questionImg.length ? questionImg.map(item => item.id)[0] : 0,
                is_read: 1,
            };
        } else {
            // 除了反馈有关的问题类型：号码占用、标记错误
            const attributionTypeVerify = await verifyCheck(attributionType, 'attributionType');
            // 如果没有选择号码实际归属，则不进行下一步操作
            if (!attributionTypeVerify) {
                return;
            }

            if (attributionType === 1) {
                const errCert = telType === 'tel' ? await verifyUploadCheck(appealData.cert, 'cert') : true;
                const errEmail = telType === 'tel' ? await verifyCheck(appealData.email, 'email') : true;
                const errEmailCode = telType === 'tel' ? await verifyCheck(appealData.emailCode, 'emailCode') : true;
                const errPhoneCode = telType === 'phone' ? await verifyCheck(appealData.phoneCode, 'phoneCode') : true;
                const errIsRead = await verifyCheck(appealData.isRead, 'isRead');
                if (errCert && errEmail && errEmailCode && errPhoneCode && errIsRead) {
                    params = {
                        ...params,
                        phone_belong: 1,
                        select: telType === 'phone' ? 2 : 1,
                        label: 1, // 无此项
                        'is_show': 0, // 开启多平台展示[无该功能]
                        phone_appeal: appealData.phone,
                        is_read: 1,
                        code: telType === 'phone' ? appealData.phoneCode : appealData.emailCode,
                    };

                    if (telType === 'tel') {
                        params = {
                            ...params,
                            cert_id: appealData.cert.map(item => item.id),
                            email: appealData.email,
                        };
                    }
                } else {
                    return;
                }
            } else if (attributionType === 2) {
                const errCompanyQualify = await verifyUploadCheck(appealData.companyQualify, 'companyQualify');
                const errCompanyName = await verifyCheck(appealData.companyName, 'companyName');
                const errCompanyAddress = await verifyCheck(appealData.companyAddress, 'companyAddress');
                const errCert = await verifyUploadCheck(appealData.cert, 'cert');
                const errEmail = await verifyCheck(appealData.email, 'email');
                const errEmailCode = await verifyCheck(appealData.emailCode, 'emailCode');
                const errIsRead = await verifyCheck(appealData.isRead, 'isRead');
                if (
                    errCompanyQualify
                    && errCompanyName
                    && errCompanyAddress
                    && errCert
                    && errEmail
                    && errEmailCode
                    && errIsRead
                ) {
                    params = {
                        ...params,
                        phone_belong: 2,
                        phone_appeal: appealData.phone,
                        'company_qualify_id': appealData.companyQualify.map(item => item.id),
                        'company_operator_id': appealData.cert.map(item => item.id),
                        name: appealData.companyName,
                        province: appealData.companyAddress.split(',')[0],
                        city: appealData.companyAddress.split(',')[1],
                        address: '',
                        email: appealData.email,
                        'code': appealData.emailCode,
                        label: 1, // 无此项
                        'is_read': 1,
                        demand: 2, // 未知字段
                        'is_show': 0, // 开启多平台展示[无该功能]
                        'industry': '' // 行业类型[无此项]
                    };
                } else {
                    return;
                }
            } else {
                const errSocial = await verifyUploadCheck(appealData.social, 'social');
                const errNameGov = await verifyCheck(appealData.nameGov, 'nameGov');
                const errCert = await verifyUploadCheck(appealData.cert, 'cert');
                const errEmail = await verifyCheck(appealData.email, 'email');
                const errEmailCode = await verifyCheck(appealData.emailCode, 'emailCode');
                const errIsRead = await verifyCheck(appealData.isRead, 'isRead');
                if (
                    errSocial
                    && errNameGov
                    && errCert
                    && errEmail
                    && errEmailCode
                    && errIsRead
                ) {
                    params = {
                        ...params,
                        phone_belong: 3,
                        name: appealData.nameGov,
                        phone_appeal: appealData.phone,
                        'social_id': appealData.social.map(item => item.id),
                        'cert_id': appealData.cert.map(item => item.id),
                        email: appealData.email,
                        code: appealData.emailCode,
                        label: 1, // 无此项
                        'is_read': 1,
                        demand: 2, // 无此项
                        'is_show': 0, // 开启多平台展示[无该功能]
                    };
                } else {
                    return;
                }
            }

            if (OCCUPY_TYPE.includes(questionType)) {
                params.appeal_type = 2;

            } else if (MARK_TYPE.includes(questionType)) {
                params.appeal_type = 1;
            }
        }
        let isPassInit = false;
        if (appealData.attributionType === 1) {
            isPassInit = true;
        }
        initCaptcha((tk) => {
            const sendSubmit = (fetchData) => appealSubmit({
                ...params,
                ...fetchData,
                svcp_stk: tk || ''
            }).then(data => {
                if (data.code === 200) {
                    const param = {
                        phone_belong: params.phone_belong,
                        phone_type: questionType,
                    };
                    recordProxy(
                        'appeal_feedback_success',
                        'click',
                        JSON.stringify(param)
                    );
                    updateAppeal({
                        curStep: 3
                    });
                    window.scrollTo(0, 0);
                } else if (data.code === 401) {
                    Modal.warning({
                        title: '结果提示',
                        content: data.message,
                        okText: '知道了',
                        centered: true
                    });
                } else {
                    message.error(data.message);
                }
            });
            bCat_2055_request(sendSubmit);
        }, isPassInit);
    };

    return (
        <div className="step-2">
            <CallingCardSelect
                data={{
                    phone: appealData.phone,
                    phoneName: appealData.phoneName,
                    titleName: appealData.titleName,
                    phoneList: appealData.phoneList
                }}
                rewrite={rewrite}
                callbackChange={onChangeCallback}
                updateData={updateAppeal}
            />
            <div style={{height: '57px'}}>
                <RadioFormItem
                    title="问题类型"
                    isMsgRequired={true}
                    type="questionType"
                    options={appealData.phoneMode === 'reports' ? QUESTION_OPTIONS2 : QUESTION_OPTIONS}
                    data={appealData}
                    updateData={updateAppeal}
                    customClassName="question-type-radio"
                    onChange={() => updateAppeal(initialQuestionStateErr)}
                />
            </div>
            {FEEDBACK_TYPE.includes(appealData.questionType) && <FeedbackModal {...props}/>}
            {BELONG_TYPE.includes(appealData.questionType) && <React.Fragment>
                <div style={{height: '57px'}}>
                    <RadioFormItem
                        title="号码实际归属"
                        isMsgRequired={true}
                        type="attributionType"
                        options={formateTypeList(appealData.phone)}
                        data={appealData}
                        updateData={updateAppeal}
                        onChange={() => updateAppeal(initialStateErr)}
                    />
                </div>
                {appealData.attributionType === 1 && <PersonModal {...props}/>}
                {appealData.attributionType === 2 && <CompanyModal {...props}/>}
                {appealData.attributionType === 3 && <GovernmentModal {...props}/>}
            </React.Fragment>}
            {(appealData.attributionType === 3 && appealData.isShowDefaultGov)
                ? null
                : <React.Fragment>
                    <AgreeProtocol
                        type="isRead"
                        data={appealData}
                        updateData={updateAppeal}
                    />
                    <div className="btn-content">
                        {!appealData.hasSearchUrl && <Button
                            className="btn-step2"
                            onClick={preClick}>上一步</Button>
                        }
                        <Button
                            className="btn-step2-primary"
                            type="primary"
                            disabled={!appealData.isRead}
                            onClick={nextClick}>提交</Button>
                    </div>
                </React.Fragment>
            }
        </div>
    );
};

Step2.propTypes = {
    updateAppeal: PropTypes.func,
    appealData: PropTypes.object,
    cleanAppeal: PropTypes.func,
    appealSubmit: PropTypes.func,
};

export default withRouter(Step2);
